/* eslint-disable no-alert */
import { Builder } from '@builder.io/react';

import IFrame from './index';

Builder.registerComponent(IFrame, {
  name: 'IFrame',
  inputs: [
    {
      name: 'url',
      type: 'string',
      defaultValue:
        'https://lidar-viewer-git-gis-viewer-scaleai.vercel.app/embed?url=demo_scene_1/scene.json'
    },
    {
      name: 'width',
      type: 'string',
      defaultValue: '100%'
    },
    {
      name: 'height',
      type: 'number',
      defaultValue: 700
    },
    {
      name: 'rounded',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'loading',
      type: 'string',
      defaultValue: 'eager',
      enum: ['eager', 'lazy']
    },
    {
      name: 'epigraph',
      type: 'string',
      defaultValue: ''
    },
    {
      name: 'placeholder',
      type: 'object',
      subFields: [
        { name: 'src', type: 'file', allowedFileTypes: ['jpg', 'png'] },
        { name: 'alt', type: 'string' },
        { name: 'width', type: 'number' },
        { name: 'height', type: 'number' }
      ]
    }
  ]
});
